import {
  PSMS_CLAIMS_SUMMARY_REQUEST,
  PSMS_MCR_INVENTORY_REQUEST,
  PSMS_MCR_EVALUATION_DETAILS_REQUEST,
  PSMSCLAIMS_APPEALS_TREND_DATA_REQUEST,
  PSMSCLAIMS_CLAIMS_TREND_DATA_REQUEST,
  PSMSCLAIMS_OUTCOME_REASONS_REQUEST,
  PSMSCLAIMS_RECON_DATA_REQUEST,
  PSMSCLAIMS_RECON_DETAILS_REQUEST,
  PSMSCLAIMS_SUBMISSION_REASONS_REQUEST,
  PSMSCLAIMS_TOPREASONS_DATA_REQUEST,
  PSMSCLAIMS_TOPREASONS_HEADER_DATA_REQUEST,
  PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST,
} from '@src/middleware/actions/actionTypes';
import {
  fetchClaimsReconDataLoading,
  fetchClaimsReconDataSuccess,
  fetchClaimsSummaryFailure,
  fetchClaimsSummaryLoading,
  fetchClaimsSummarySuccess,
  fetchClaimsTrendDataLoading,
  fetchClaimsTrendDataSuccess,
  fetchMcrInventoryFailure,
  fetchMcrInventoryLoading,
  fetchMcrInventorySuccess,
  fetchPSMSAppealTrendDataError,
  fetchPSMSAppealTrendDataLoading,
  fetchPSMSAppealTrendDataSuccess,
  fetchPsmsOutcomeReasonsFailure,
  fetchPsmsOutcomeReasonsLoading,
  fetchPsmsOutcomeReasonsSuccess,
  fetchPsmsReconDetailsFailure,
  fetchPsmsReconDetailsLoading,
  fetchPsmsReconDetailsSuccess,
  fetchPsmsSubmissionReasonsFailure,
  fetchPsmsSubmissionReasonsLoading,
  fetchPsmsSubmissionReasonsSuccess,
  fetchTopReasonsDataError,
  fetchTopReasonsDataLoading,
  fetchTopReasonsDataSuccess,
  fetchTopReasonsHeaderDataLoading,
  fetchTopReasonsHeaderDataSuccess,
  fetchMcrEvaluationDetailsLoading,
  fetchMcrEvaluationDetailsSuccess,
  fetchMcrEvaluationDetailsFailure,
  fetchClaimsAppealsSubmissionLoading,
  fetchClaimsAppealsSubmissionSuccess,
  fetchClaimsAppealsSubmissionFailure,
  fetchTopReasonsHeaderDataError,
  fetchClaimsTrendDataError,
} from '@src/middleware/actions/psms/claimActions';
import { Action } from 'redux';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
// import {
//   getAppealTrendData,
//   getTopReasonTopCategory,
//   getTopReasonSubCategory,
//   getNonPaymentDetails,
// } from '@src/middleware/services/psms/claims/claims.service.mock';
import {
  getMcrInventoryData,
  getClaimsSummaryData,
  getClaimsAppealsSummaryData,
  getClaimsBifurcateMetricsData,
  getClaimsReconDetailsData,
  getClaimsYieldPassWiseMetricsData,
  getAutomationRateClaimMetricsData,
  getClaimsYieldAllPassesMetricsData,
  getPsmsOutcomeReasons,
  getPsmsSubmissionReasons,
  getPsmsReconDetails,
  getClaimsReconTatDetails,
  getClaimsReconDetails,
  getClaimsTrendData,
  getAppealTrendData,
  getTopReasonTopCategory,
  getTopReasonSubCategory,
  getNonPaymentDetails,
  getMcrEvaluationDetails,
  getClaimsAppealsSubmissiondData,
} from '@src/middleware/services/psms/claims/claims.service';
import { getPsmsState } from '@src/middleware/selectors/psms/psmsSelectors';

// Define the shape of the action payload if needed
interface FetchClaimsAction extends Action {
  payload?: any;
}

// Worker saga: will be fired on FETCH_CLAIMS_REQUEST actions
function* fetchClaimsSaga(action: FetchClaimsAction) {}

// Watcher saga: spawns a new fetchClaimsSaga task on each FETCH_CLAIMS_REQUEST
export function* watchClaimsSaga() {}

export function* fetchClaimsTrendData(action: any) {
  try {
    yield put(fetchClaimsTrendDataLoading(true));
    const response = yield call(getClaimsTrendData, action.payload);
    if (response) {
      yield put(fetchClaimsTrendDataSuccess(response));
    } else {
      yield put(fetchClaimsTrendDataError('Failed to fetch claims trend data'));
    }
  } catch (error) {
    yield put(fetchClaimsTrendDataError(error));
  } finally {
    yield put(fetchClaimsTrendDataLoading(false));
  }
}

export function* fetchAppealTrendData(action: any) {
  try {
    yield put(fetchPSMSAppealTrendDataLoading(true));
    const LobData: { Lob: string }[] = [
      { Lob: 'All' },
      { Lob: 'EI' },
      { Lob: 'MR' },
      { Lob: 'CS' },
      { Lob: 'EXC' },
    ];
    const allResponses: any[] = [];
    for (const lobItem of LobData) {
      const payloadWithLob = {
        ...action.payload,
        Lob: lobItem.Lob,
        appealsProcessing: 'Received Date',
      };
      const response: Awaited<ReturnType<typeof getAppealTrendData>> = yield call(
        getAppealTrendData,
        payloadWithLob
      );
      if (response) {
        allResponses.push({
          Lob: lobItem.Lob,
          ...response,
        });
      }
    }
    yield put(fetchPSMSAppealTrendDataSuccess(allResponses));
  } catch (error) {
    yield put(fetchPSMSAppealTrendDataError(error));
  } finally {
    yield put(fetchPSMSAppealTrendDataLoading(false));
  }
}

export function* fetchTopReasonsHeaderData(action: any) {
  try {
    yield put(fetchTopReasonsHeaderDataLoading(true));

    const response = yield call(getNonPaymentDetails, action?.payload);

    if (response) {
      yield put(fetchTopReasonsHeaderDataSuccess(response));
    } else {
      yield put(fetchTopReasonsHeaderDataError('Incomplete response from API'));
    }
  } catch (error) {
    yield put(fetchTopReasonsHeaderDataError(error));
  } finally {
    yield put(fetchTopReasonsHeaderDataLoading(false));
  }
}

export function* fetchTopReasonsData(action: any) {
  try {
    const ClaimsBy = action?.payload?.ClaimsBy;
    const DenialType = action?.payload?.DenialType;
    yield put(fetchTopReasonsDataLoading(true));
    if (ClaimsBy === 'DOP') {
      action.payload.ReportType = 'subject';
    }

    // First API call based on the initial payload
    const initialResponse = yield call(getTopReasonTopCategory, action?.payload);

    if (
      initialResponse &&
      (initialResponse.Status === 'OK' || initialResponse.Status === 'MULTI_STATUS')
    ) {
      // Extract categories based on ClaimsBy value
      let denialCategories = [];

      if (ClaimsBy === 'DOP') {
        // Try to safely extract the categories
        if (Array.isArray(initialResponse?.Data?.DenialCategory)) {
          denialCategories = initialResponse.Data.DenialCategory.map(
            (detail: any) => detail.ClaimDenialCategoryLevel1ShortName
          ).filter(Boolean);
        }
      } else {
        // Non-DOP flow remains the same
        denialCategories =
          initialResponse?.Data[0]?.All?.DenialCategory?.map(
            (detail: any) => detail.ClaimDenialCategoryLevel1ShortName
          ) || [];
      }

      const allResponses: any[] = [];
      // Sequentially call the API for each reason in the payload
      for (const denialCategory of denialCategories) {
        if (!denialCategory) continue; // Skip if category name is undefined

        yield put(fetchTopReasonsDataLoading(true));
        const response = yield call(getTopReasonSubCategory, {
          ...action.payload,
          DenialCategory: denialCategory,
        });

        if (response && (response.Status === 'OK' || response.Status === 'MULTI_STATUS')) {
          allResponses.push(response);
        }
      }

      // comment out below code and uncomment above code when need to call actual API for each sub category, currently calling API once with hard coded value for testing purpose
      // const allResponses = yield call(getTopReasonSubCategory, {
      //   ClaimsBy: 'DOS',
      // });

      // Combine all responses and dispatch success action
      yield put(fetchTopReasonsDataSuccess({ initialResponse, allResponses }));
    } else {
      yield put(fetchTopReasonsDataError('Invalid response from API'));
    }

    yield put(fetchTopReasonsDataLoading(false));
  } catch (error) {
    yield put(fetchTopReasonsDataError(error));
    yield put(fetchTopReasonsDataLoading(false));
  }
}

// combined saga to fetch claims recon details and TAT details together
export function* fetchClaimsReconData(action: any) {
  try {
    yield put(fetchClaimsReconDataLoading(true));
    const [claimsReconDetail, claimsReconTat] = yield all([
      call(getClaimsReconDetails, action?.payload),
      call(getClaimsReconTatDetails, action?.payload),
    ]);
    yield put(fetchClaimsReconDataSuccess({ claimsReconDetail, claimsReconTat }));
  } catch (error) {
    // yield put(fetchClaimsReconDataError(error));
  } finally {
    yield put(fetchClaimsReconDataLoading(false));
  }
}

function* handleFetchClaimsSummary(action: any) {
  try {
    yield put(fetchClaimsSummaryLoading(true));

    const psmsState = yield select(getPsmsState);
    const isGeoFlow = psmsState?.currentFlow === 'GEO_FLOW';
    const isDOP = action.payload?.ClaimsBy === 'DOP';
    const Lob = action.payload?.Lob && action.payload.Lob !== 'All';
    const mcrPayload = {
      ...action.payload,
      Market:
        Array.isArray(action.payload?.Market) && action.payload.Market.length > 0
          ? action.payload.Market.join('|')
          : action.payload?.Market,
    };

    const results = yield all([
      call(function* () {
        try {
          return yield call(getClaimsSummaryData, action.payload);
        } catch (error) {
          return null;
        }
      }),
      call(function* () {
        if (isGeoFlow || isDOP) return null;
        try {
          return yield call(getClaimsAppealsSummaryData, action.payload);
        } catch (error) {
          return null;
        }
      }),
      call(function* () {
        try {
          return yield call(getClaimsBifurcateMetricsData, action.payload);
        } catch (error) {
          return null;
        }
      }),
      call(function* () {
        if (isDOP) return null;
        try {
          return yield call(getClaimsReconDetailsData, action.payload);
        } catch (error) {
          return null;
        }
      }),
      call(function* () {
        if (Lob) return null;
        try {
          return yield call(getMcrInventoryData, mcrPayload);
        } catch (error) {
          return null;
        }
      }),
      call(function* () {
        try {
          return yield call(getClaimsYieldPassWiseMetricsData, action.payload);
        } catch (error) {
          return null;
        }
      }),
      call(function* () {
        try {
          return yield call(getAutomationRateClaimMetricsData, action.payload);
        } catch (error) {
          return null;
        }
      }),
      call(function* () {
        try {
          return yield call(getClaimsYieldAllPassesMetricsData, action.payload);
        } catch (error) {
          return null;
        }
      }),
    ]);

    const [
      processedResponse,
      appealsResponse,
      denialsResponse,
      reconResponse,
      mcrResponse,
      yieldResponse,
      automationResponse,
      firstPassResponse,
    ] = results;

    // Structure the data with keys for each card
    const structuredData: any = {};

    // Process "Processed" card data
    if (processedResponse?.StatusCode === 200 || processedResponse?.StatusCode === 207) {
      structuredData.processedCard = processedResponse.Data;
    }

    // Process "Appeals" card data
    if (appealsResponse?.StatusCode === 200 || appealsResponse?.StatusCode === 207) {
      structuredData.appealsCard = appealsResponse.Data;
    }

    // Process "Complete Denials" card data
    if (denialsResponse?.StatusCode === 200 || denialsResponse?.StatusCode === 207) {
      structuredData.denialsCard = denialsResponse.Data;
    }

    // Process "Reconsideration" card data
    if (reconResponse?.StatusCode === 200 || reconResponse?.StatusCode === 207) {
      structuredData.reconCard = reconResponse.Data;
    }

    // Process "MCR Inventory" card data
    if (mcrResponse?.StatusCode === 200 || mcrResponse?.StatusCode === 207) {
      structuredData.mcrCard = mcrResponse.Data;
    }

    // Process "Payment Yield" card data
    if (yieldResponse?.StatusCode === 200 || yieldResponse?.StatusCode === 207) {
      structuredData.yieldCard = yieldResponse.Data;
    }

    // Process "Automation Rate" card data
    if (automationResponse?.StatusCode === 200 || automationResponse?.StatusCode === 207) {
      structuredData.automationCard = automationResponse.Data;
    }

    // Process "First Pass" card data
    if (firstPassResponse?.StatusCode === 200 || firstPassResponse?.StatusCode === 207) {
      structuredData.firstPassCard = firstPassResponse.Data;
    }

    // Dispatch success with structured data
    if (Object.keys(structuredData).length > 0) {
      yield put(fetchClaimsSummarySuccess(structuredData));
    } else {
      yield put(fetchClaimsSummaryFailure('No data available from any API.'));
    }
  } catch (error: any) {
    if (error?.response?.status === 504) {
      yield put(fetchClaimsSummaryFailure('Server timeout. Please try again later.'));
    } else {
      yield put(fetchClaimsSummaryFailure(error?.message || 'Failed to fetch Claims Summary data'));
    }
  } finally {
    yield put(fetchClaimsSummaryLoading(false));
  }
}

function* handleFetchMcrInventory(action: any) {
  try {
    yield put(fetchMcrInventoryLoading(true));
    let response = yield call(getMcrInventoryData, action.payload);

    if (response?.status === 504) {
      response = yield call(getMcrInventoryData, action.payload);
    }

    const data = response?.Data?.[0];
    if (!data) {
      yield put(fetchMcrInventorySuccess(undefined));
      yield put(fetchMcrInventoryFailure('No data available.'));
    } else {
      yield put(fetchMcrInventorySuccess(data));
    }
  } catch (error: any) {
    if (error?.response?.status === 504) {
      yield put(fetchMcrInventorySuccess(undefined));
      yield put(fetchMcrInventoryFailure('Server timeout. Please try again later.'));
    } else {
      yield put(fetchMcrInventoryFailure(error?.message || 'Failed to fetch MCR Inventory data'));
    }
  } finally {
    yield put(fetchMcrInventoryLoading(false));
  }
}

export function* handleFetchMcrEvaluationDetails(action: any) {
  try {
    yield put(fetchMcrEvaluationDetailsLoading(true));
    const response = yield call(getMcrEvaluationDetails, action?.payload, 'ANNUAL');
    if (response && (parseInt(response?.StatusCode) === 200 || response?.Status === 'OK')) {
      yield put(fetchMcrEvaluationDetailsSuccess(response?.Data || []));
    } else {
      yield put(
        fetchMcrEvaluationDetailsFailure(response?.Message || 'Failed to fetch evaluation details')
      );
    }
  } catch (error: any) {
    yield put(
      fetchMcrEvaluationDetailsFailure(error?.message || 'Failed to fetch evaluation details')
    );
  } finally {
    yield put(fetchMcrEvaluationDetailsLoading(false));
  }
}

export function* fetchClaimsAppealsSubmissionSaga(action: any) {
  try {
    yield put(fetchClaimsAppealsSubmissionLoading(true));
    const response = yield call(getClaimsAppealsSubmissiondData, action?.payload);

    if (response) {
      yield put(fetchClaimsAppealsSubmissionSuccess(response?.Data || []));
    }
  } catch (error) {
    yield put(fetchClaimsAppealsSubmissionFailure(error));
  } finally {
    yield put(fetchClaimsAppealsSubmissionLoading(false));
  }
}

// Root saga for claims
export default function* claimsSaga() {
  yield watchClaimsSaga();
  yield takeLatest(PSMSCLAIMS_APPEALS_TREND_DATA_REQUEST, fetchAppealTrendData);
  yield takeLatest(PSMS_MCR_INVENTORY_REQUEST, handleFetchMcrInventory),
    yield takeLatest(PSMS_CLAIMS_SUMMARY_REQUEST, handleFetchClaimsSummary);
  yield takeLatest(PSMS_MCR_EVALUATION_DETAILS_REQUEST, handleFetchMcrEvaluationDetails);
  yield takeLatest(PSMSCLAIMS_TOPREASONS_DATA_REQUEST, fetchTopReasonsData);
  yield takeLatest(PSMSCLAIMS_TOPREASONS_HEADER_DATA_REQUEST, fetchTopReasonsHeaderData);
  yield takeLatest(PSMSCLAIMS_CLAIMS_TREND_DATA_REQUEST, fetchClaimsTrendData);
  yield takeLatest(PSMSCLAIMS_RECON_DATA_REQUEST, fetchClaimsReconData);
  yield takeLatest(PSMSCLAIMS_OUTCOME_REASONS_REQUEST, fetchOutcomeReasonsSaga);
  yield takeLatest(PSMSCLAIMS_SUBMISSION_REASONS_REQUEST, fetchSubmissionReasonsSaga);
  yield takeLatest(PSMSCLAIMS_RECON_DETAILS_REQUEST, fetchReconDetailsSaga);
  yield takeLatest(PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST, fetchClaimsAppealsSubmissionSaga);
}

export function* fetchOutcomeReasonsSaga(action: any) {
  try {
    yield put(fetchPsmsOutcomeReasonsLoading(true));
    const response = yield call(getPsmsOutcomeReasons, action?.payload);
    if (response && parseInt(response?.StatusCode) === 200) {
      const sortedData =
        response?.Data?.sort((a: any, b: any) => {
          if (b.ReconConclusionReasonPercentage !== a.ReconConclusionReasonPercentage) {
            return b.ReconConclusionReasonPercentage - a.ReconConclusionReasonPercentage;
          }
          return b.ReconConclusionReasonVolume - a.ReconConclusionReasonVolume;
        }) || [];
      yield put(fetchPsmsOutcomeReasonsSuccess(sortedData));
    } else {
      yield put(
        fetchPsmsOutcomeReasonsFailure(response?.Message || 'Failed to fetch outcome reasons')
      );
    }
  } catch (error) {
    yield put(fetchPsmsOutcomeReasonsFailure(error));
  } finally {
    yield put(fetchPsmsOutcomeReasonsLoading(false));
  }
}

export function* fetchSubmissionReasonsSaga(action: any) {
  try {
    yield put(fetchPsmsSubmissionReasonsLoading(true));
    const response = yield call(getPsmsSubmissionReasons, action?.payload);
    if (response && parseInt(response?.StatusCode) === 200) {
      const sortedData =
        response?.Data?.sort((a: any, b: any) => {
          if (b.ReconRequestReasonPercentage !== a.ReconRequestReasonPercentage) {
            return b.ReconRequestReasonPercentage - a.ReconRequestReasonPercentage;
          }
          return b.ReconRequestReasonVolume - a.ReconRequestReasonVolume;
        }) || [];
      yield put(fetchPsmsSubmissionReasonsSuccess(sortedData));
    } else {
      yield put(
        fetchPsmsSubmissionReasonsFailure(response?.Message || 'Failed to fetch submission reasons')
      );
    }
  } catch (error) {
    yield put(fetchPsmsSubmissionReasonsFailure(error));
  } finally {
    yield put(fetchPsmsSubmissionReasonsLoading(false));
  }
}

export function* fetchReconDetailsSaga(action: any) {
  try {
    yield put(fetchPsmsReconDetailsLoading(true));
    const response = yield call(getPsmsReconDetails, action?.payload);
    if (response && parseInt(response?.StatusCode) === 200) {
      yield put(fetchPsmsReconDetailsSuccess(response?.Data || {}));
    } else {
      yield put(
        fetchPsmsReconDetailsFailure(response?.Message || 'Failed to fetch reconsideration details')
      );
    }
  } catch (error) {
    yield put(fetchPsmsReconDetailsFailure(error));
  } finally {
    yield put(fetchPsmsReconDetailsLoading(false));
  }
}
